export default __webpack_public_path__ + "static/media/icons-users.4e50e052.svg";